<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <el-row :gutter="20" id="mision">
        <el-col class="hidden-sm-and-down" :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Misión y Visión</h1></el-col>
        <el-col class="hidden-md-and-up" :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Misión</h1></el-col>
        <br>
        <el-col :xs="24" :md="12"><p class="chevere-text-j">Ofrecer a nuestros clientes las herramientas que faciliten el día a día en sus labores, automatizando sus procesos de gestión que consumen mucho tiempo y recurso humano, para así garantizar su crecimiento y mejora de sus tiempos de respuesta.</p></el-col>

        <el-col class="hidden-md-and-up" :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Visión</h1></el-col>

        <el-col :xs="24" :md="12"><p class="chevere-text-j">Ser una de las principales empresas desarrolladoras de software a nivel nacional e internacional, brindando aplicativos que fortalezcan y agilicen las operaciones y procesos en todas las áreas de las organizaciones de nuestros clientes, usando las tecnologías más recientes y dando el mejor soporte y asesoría ante adversidades que puedan tener.</p></el-col>
    </el-row>
</template>

<script>
export default {
    name: "Mision",
}
</script>

<style scoped>

</style>





// WEBPACK FOOTER //
// src/sections/Mision.vue